module.exports = __webpack_public_path__ + "static/img/f3.8af4becf.png";